import { Component, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { BaseRouterComponent } from 'src/app/modules/aa-core/components/base-router/base-router.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { SeoMetaService } from 'src/app/modules/aa-core/services/seo-meta-service';
import { RoutePlannerPrintService } from 'src/app/modules/route-planner/services/route-planner-print/route-planner-print.service';
import { EventsService } from 'src/app/core/services/events.service';
import { AARouterURL } from 'src/app/modules/app-routing/enums/routing.enum';
import { AppRouterDataService } from 'src/app/modules/app-routing/services/app-router-data/app-router-data.service';

@Component({
    selector: 'aa-map-print-preview',
    templateUrl: './map-print-preview.component.html',
    styleUrls: ['./map-print-preview.component.scss'],
    standalone: false
})
export class MapPrintPreviewComponent extends BaseRouterComponent implements OnDestroy {

  public openPrintModal: boolean;

  constructor(private routePrintService: RoutePlannerPrintService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private cdr: ChangeDetectorRef,
    public appRouterDataService: AppRouterDataService,
    public eventsService: EventsService,
    public appUtilityService: AppUtilityService,
    public seoService: SeoMetaService) {
    super(activatedRoute, router, appUtilityService, seoService);
    this.openPrintModal = true;
    this.apply();
  }

  public closeModel() {
    // this.eventsService.dispatch(PrintRoutePlanner.CLOSE_PRINT_PREVIEW);
    this.openPrintModal = false;
    this.appRouterDataService.updateURL(AARouterURL.MAP_PRINT_PREVIEW_CLOSE);
  }

  public printMap(): void {
    this.routePrintService.print();
  }

  private apply(): void {
    setTimeout(() => {
      this.cdr.detectChanges();
    }, 10);
  }

  ngOnDestroy() {
    this.unSubscribeObservableEvents();
  }

}
